var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleModuleDashboard',{attrs:{"module-id":_vm.Modules.EMPLEADOS,"profile-id":_vm.Profiles.PERSONAL,"include-php-custom":"","actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }